export const PortalApiPath = {
  PORTAL_SEARCH: '/api/portal/search', // GET Portal Search
  PORTAL_PRODUCTS: '/api/portal/products', // GET Portal Products
  PORTAL_TRENDING: '/api/portal/trending' // GET Portal Trending
}

export type PortalApiPath = (typeof PortalApiPath)[keyof typeof PortalApiPath]

export interface PortalSearchVars {
  q?: string
  category?: string
  min_rating?: number
  sort?: string
  page?: number
  per_page?: number
}

export interface PortalProductsVars {
  page?: number
  per_page?: number
}

export interface PortalTrendingVars {
  limit?: number
}

export interface PortalUGCItem {
  id: number
  source_type: string
  caption: string | null
  media_url: string | null
  author_name: string | null
  rating: number | null
  ai_score: number | null
  product_id: string | null
  site_id: number
}

export interface PortalProduct {
  product_id: string
  product_name: string
  image_url: string | null
  price: number | null
  review_count: number
  avg_rating: number
}

export interface PortalSearchResponse {
  items: PortalUGCItem[]
  total: number
  page: number
  query: string
}

export interface PortalProductsResponse {
  products: PortalProduct[]
  page: number
}

export interface PortalTrendingItem {
  id: number
  caption: string
  media_url: string | null
  author_name: string | null
  rating: number | null
  ai_score: number | null
}

export interface PortalTrendingResponse {
  items: PortalTrendingItem[]
}
